import {
    AddressAmabis,
    AddressAmabisProps,
    AmabisConfig,
    AmabisProvider,
} from '@axa-fr-axion/input-amabis';
import { QueryClientProvider } from '@tanstack/react-query';
import { AMABIS_ENDPOINT, AMABIS_HOST, DISABLE_DELAY, HEADERS_CORRELATION_NAME } from 'utils';
import { getQueryClient } from 'utils/query-client';

const amabisConfig: AmabisConfig = {
    isDelayDisabled: DISABLE_DELAY,
    headersCorrelationName: HEADERS_CORRELATION_NAME,
    amabisHost: AMABIS_HOST,
    amabisEndpoint: AMABIS_ENDPOINT,
};

const queryClient = getQueryClient();

export const ADDRESS_LABEL = 'N°, nom de la voie, code postal *';

export function Address({ ...props }: AddressAmabisProps): JSX.Element {
    return (
        <QueryClientProvider client={ queryClient }>
            <AmabisProvider config={ amabisConfig }>
                <AddressAmabis { ...props } />
            </AmabisProvider>
        </QueryClientProvider>
    );
}
